// extracted by css-extract-rspack-plugin
export default {"withMinimalCard":"ContentfulCards-module__withMinimalCard__IkHNH"};